const GernalGoods = () => import('@/modules/fwsc/goodsInfo/gernalGoogslist')
const CustomReviews = () => import('@/modules/fwsc/customreview/CustomReviewlist')
const SellerOrderlist = () => import('@/modules/fwsc/SellerOrder/SellerOrderlist')
const SellerCompactList = () => import('@/modules/fwsc/SellerCompact/SellerCompactList')
const SellerPaylist = () => import('@/modules/fwsc/payInfo/SellerPaylist')
const GoodsDustbinList = () => import('@/modules/fwsc/goodsdustbin/GoodsDustbinList')
const YearFeeRecordList = () => import('@/modules/fwsc/yearfeerecord/YearFeeRecordList')
export default [
  {

    path: '/fwsc/gernalGoodslist',
    name: 'fwscGernalgood',
    component: GernalGoods,
    meta: {
      title: '普通商品管理',
      isBlack: true
    },
  },

  {

    path: '/fwsc/fwscOrderlist',
    name: 'fwscOrderlist',
    component: SellerOrderlist,
    meta: {
      title: '订单管理',
      isBlack: true
    },
  },
  {

    path: '/fwsc/compactList',
    name: 'fwscCompactlist',
    component: SellerCompactList,
    meta: {
      title: '合同管理',
      isBlack: true
    },
  },
  {

    path: '/fwsc/customReviews',
    name: 'fwscKhpj',
    component: CustomReviews,
    meta: {
      title: '客户评价管理',
      isBlack: true
    },
  },
  {

    path: '/fwsc/wallet',
    name: 'fwscSellerPay',
    component: SellerPaylist,
    meta: {
      title: '钱包管理',
      isBlack: true
    },
  },
  {

    path: '/goodsdustbin',
    name: 'goodsdustbin',
    component: GoodsDustbinList,
    meta: {
      title: '商品回收站',
      isBlack: true
    },
  },
  {

    path: '/yearfeerecord',
    name: 'yearfeerecord',
    component: YearFeeRecordList,
    meta: {
      title: '年费缴纳记录',
      isBlack: true
    },
  },
]
